const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const deleteAllowedIpApi = async (id) => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[deleteAllowedIpApi] Помилка: Токен авторизації не знайдено.');
    throw new Error('Токен авторизації не знайдено.');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/allowed-ips/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[deleteAllowedIpApi] Помилка при видаленні IP:', errorData);
      
      throw { ...errorData, statusCode: response.status };
    }
    return;
  } catch (error) {
    console.error('[deleteAllowedIpApi] Мережева або інша помилка при видаленні IP:', error);
    throw error;
  }
};